/*
  Array map of currencies to sort by in the currency dropdown.
  Add more to this array for custom currency sorting.
*/
export const currencyOrder = ["USD", "EUR", "GBP", "CAD", "AUD", "NZD"];
//# sourceMappingURL=constants.js.map
// @zapier/checkout@7.13.0 (cd15c152f)
